import * as portableFetch from 'portable-fetch';
import { FetchAPI } from '../userApi';

/** Reject 2xx responses with an empty body before swagger client calls response.json(). */
export const safeJsonFetch: FetchAPI = (url, options) =>
  portableFetch(url, options).then((response) => {
    if (response.status < 200 || response.status >= 300) {
      return response;
    }
    // Like/flag create return 201 with an empty body; deletes return 204.
    // Do not treat empty success bodies as errors — only JSON-expecting
    // callers would otherwise fail on response.json().
    if (response.status === 201 || response.status === 204) {
      return response;
    }
    return response.clone().text().then((text) => {
      if (!text || !text.trim()) {
        throw response;
      }
      return response;
    });
  });
